import { Flex, Group, Pill, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { Content, EditButtonLink } from '@/core/components';

import { Publisher } from './model/PublisherTypes';

interface PublisherViewProps {
  publisher: Publisher;
}

export function PublisherView(props: PublisherViewProps) {
  const { publisher } = props;
  const { title, type, address, peerReview, prestige } = publisher;
  const { t } = useTranslation();

  return (
    <Stack>
      <Content type="full">
        <Stack gap="10px">
          <Flex justify="space-between">
            <Text fw="500">{title}</Text>
            <Group>
              <EditButtonLink
                size="xs"
                miw="100px"
              />
              {/*<PublisherDeleteButton publisherId={publisher.id} /> TODO ENABLE AFTER SECURITY CHECK*/}
            </Group>
          </Flex>
          <Group>
            <Text
              c="dimmed"
              size="sm"
            >
              {address}
            </Text>
          </Group>
          <Group>
            <Pill>{type?.name}</Pill>
            {prestige === 'YES' && <Pill>{t('publishers.view.prestige')}</Pill>}
            {peerReview === 'YES' && <Pill>{t('publishers.view.peerReview')}</Pill>}
          </Group>
        </Stack>
      </Content>
    </Stack>
  );
}
